// Shows [data-discount-notice] (snippets/discount-notice.liquid) once per
// discount code after the visitor arrives through a /discount/CODE link.
// Shopify stores the code in the `discount_code` cookie; whether it is valid
// is only known once the cart or checkout applies it.
(() => {
  const KEY = 'maru:discount-notice';
  const VISIBLE_FOR = 10000;

  const notice = document.querySelector('[data-discount-notice]');
  const message = notice?.querySelector('[data-discount-notice-message]');
  if (!notice || !message) return;

  const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
  if (!match) return;

  let code;
  try {
    code = decodeURIComponent(match[1]);
  } catch (error) {
    return;
  }

  // Without storage the toast would return on every page: stay quiet.
  try {
    if (localStorage.getItem(KEY) === code) return;
    localStorage.setItem(KEY, code);
  } catch (error) {
    return;
  }

  message.textContent = message.dataset.template.replace('[code]', code);
  notice.hidden = false;

  const hide = () => {
    notice.hidden = true;
  };
  notice.querySelector('[data-discount-notice-close]')?.addEventListener('click', hide);
  setTimeout(hide, VISIBLE_FOR);
})();
